import gif from "../../assets/img/go-gif.gif";
import figmaLogo from "../../assets/img/figma-logo.png";
import pythonLogo from "../../assets/img/python-logo.png";
import { FaCss3 } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";
import { TbBrandJavascript } from "react-icons/tb";
import { FaReact } from "react-icons/fa";
import { SiTailwindcss } from "react-icons/si";
import { BsBootstrapFill } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { SiFastapi } from "react-icons/si";
import { FaHtml5 } from "react-icons/fa";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const AboutMe = () => {
    return (
        <>
            <div className="pt-16 flex flex-col items-center justify-center w-full bg-[#f9f9f9] pb-28 rounded-t-3xl relative bottom-5">
                <div className="hidden lg:block">
                    <div id="loading" className="mb-5 ">
                        <div id="loading-dot"></div>
                    </div>
                </div>

                {/* About Section */}
                <div className="flex flex-col items-center justify-center w-full py-3 gap-y-2">
                    <h6 className="text-[26px] sm:text-[32px] md:text-[40px] font-bold ">
                        {" "}
                        ABOUT ME
                    </h6>
                    <div className="section-line"></div>
                    <p className="text-[16px] md:text-[20px] w-[97%] sm:w-[90%] md:w-[65%] lg:w-[55%] xl:w-[47%] text-center text-[#555555]">
                        Here you will find more information about me, what I do,
                        and my current skills mostly in terms of programming and
                        technology
                    </p>

                    <div className="w-full lg:w-[96%] xl:w-[80%] pb-2 pt-3 px-3 lg:mt-4">
                        <Link
                            to="/about-me"
                            className="hover:no-underline hover:text-black"
                        >
                            <div
                                className="text-[20px] mt-4 md:mt-0 py-2 w-[220px] md:w-[310px]  justify-center md:text-[28px] font-bold xl:ml-[40px] content-center flex items-center bg-white rounded-full "
                                data-aos="slide-right"
                                data-aos-offset="100"
                                data-aos-delay="100"
                            >
                                <h6>Get to know me!</h6>
                                <img
                                    
                                    src={gif}
                                    height
                                    alt="gif"
                                    className="ml-2 rotate-180 h-7 md:h-10"
                                />
                            </div>
                        </Link>

                        {/* info */}
                        <div className="flex flex-col gap-y-5 lg:flex-row items-start justify-around w-full text-[14px] sm:text-[16px] md:text-lg text-[#555555] py-4">
                            <p
                                className="lg:max-w-[320px]"
                                data-aos="fade-right"
                                data-aos-offset="100"
                                data-aos-delay="100"
                            >
                                As a <b>Full Stack Developer</b> and skilled
                                web designer, adept at crafting seamless user
                                experiences and robust functionalities for
                                websites and web applications. Check out some of
                                my work in the{" "}
                                <Link
                                    to="/my-projects"
                                    className="font-bold underline hover:text-black"
                                >
                                    My Projects
                                </Link>{" "}
                                page.
                            </p>

                            <p
                                className="lg:max-w-[460px]"
                                data-aos="fade-right"
                                data-aos-offset="100"
                                data-aos-delay="200"
                            >
                                I also like sharing content related to the stuff
                                that I have learned over the years in{" "}
                                <b>Web Development</b> so it can help other
                                people of the Dev Community. Feel free to
                                Connect or Follow me on my{" "}
                                <a
                                    href="https://www.linkedin.com/in/gulfam-haider-861016291/"
                                    target="_blank" rel="noopener noreferrer"
                                    className="font-bold underline hover:text-black"
                                >
                                    Linkedin
                                </a>{" "}
                                where I have over <b>5K+</b> followers,I post
                                useful content related to Web Development and
                                Programming. Learn about me more in the{" "}
                                <Link
                                    to="/about-me"
                                    className="font-bold underline hover:text-black"
                                >
                                    About Me
                                </Link>{" "}
                                page.
                            </p>

                            <p
                                className="lg:max-w-[220px]"
                                data-aos="fade-right"
                                data-aos-offset="100"
                                data-aos-delay="300"
                            >
                                I'm open to project offers where I can
                                contribute, learn, and grow. If you have a good
                                offer that matches my skills and experience then
                                don't hesitate to{" "}
                                <Link
                                    to="/contact-me"
                                    className="font-bold underline hover:text-black"
                                >
                                    Contact Me
                                </Link>
                                .
                            </p>
                        </div>
                    </div>
                </div>

                {/* This div is for slider */}
                <div className=" flex w-[98%] md:w-[70%] justify-center md:flex-row flex-col md:items-center md:py-3   text-black  font-bold">
                    <div className="flex flex-col justify-center pb-4 md:border-r-2 md:pr-8 md:py-4 ">
                        <p className=" font-bold text-[24px] text-center md:text-justify text-[#555555]">
                            Expertise
                        </p>
                    </div>

                    {/* This div is for image slider */}

                    <div className="flex justify-center overflow-hidden text-black w-full lg:w-[77%]">
                        <div className="inline-flex gap-8 w-[100%] ">
                            <div class="logos">
                                <div class="logos-slide gap-x-[25px] md:gap-x-[30px]">
                                    <SiNextdotjs
                                        size={70}
                                        title="Next.js"
                                        className="text-black"
                                    />
                                    <FaReact
                                        size={70}
                                        title="React.js"
                                        className="text-[#006C96]"
                                    />
                                    <TbBrandJavascript
                                        size={70}
                                        title="Javascript"
                                        className="text-[#F3E159]"
                                    />
                                    <img
                                        src={pythonLogo}
                                        alt="python logo"
                                        title="Python"
                                        className="h-[66px]"
                                    />
                                    <SiFastapi
                                        size={70}
                                        title="FastAPI"
                                        className="text-[#059286]"
                                    />
                                    <FaHtml5
                                        size={70}
                                        title="HTML"
                                        className="text-[#F75F2A]"
                                    />
                                    <FaCss3
                                        size={70}
                                        title="CSS"
                                        className="text-[#2862E9]"
                                    />
                                    <SiTailwindcss
                                        size={70}
                                        title="TailwindCSS"
                                        className="text-[#36B7F0]"
                                    />
                                    <BsBootstrapFill
                                        size={70}
                                        title="Bootstrap"
                                        className="text-[#7710F1]"
                                    />
                                    <FaGithub
                                        size={70}
                                        title="Github"
                                        className="text-black"
                                    />
                                    <img
                                        src={figmaLogo}
                                        alt="figma"
                                        title="Figma"
                                        className="h-[66px] relative right-0"
                                    />
                                    <SiNextdotjs
                                        size={70}
                                        title="Next.js"
                                        className="text-black"
                                    />
                                    <FaReact
                                        size={70}
                                        title="React.js"
                                        className="text-[#006C96]"
                                    />
                                    <TbBrandJavascript
                                        size={70}
                                        title="Javascript"
                                        className="text-[#F3E159]"
                                    />
                                    <img
                                        src={pythonLogo}
                                        alt="python"
                                        title="Python"
                                        className="h-[66px]"
                                    />
                                    <SiFastapi
                                        size={70}
                                        title="FastAPI"
                                        className="text-[#059286]"
                                    />
                                    <FaHtml5
                                        size={70}
                                        title="HTML"
                                        className="text-[#F75F2A]"
                                    />
                                    <FaCss3
                                        size={70}
                                        title="CSS"
                                        className="text-[#2862E9]"
                                    />
                                    <SiTailwindcss
                                        size={70}
                                        title="TailwindCSS"
                                        className="text-[#36B7F0]"
                                    />
                                    <BsBootstrapFill
                                        size={70}
                                        title="Bootstrap"
                                        className="text-[#7710F1]"
                                    />
                                    <FaGithub
                                        size={70}
                                        title="Github"
                                        className="text-black"
                                    />
                                    <img
                                        src={figmaLogo}
                                        alt="figma"
                                        title="Figma"
                                        className="h-[66px] relative right-3"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutMe;
